import { Carousel } from "react-bootstrap";
import ReactPlayer from "react-player";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const VideoSection = ({ videos, loading }) => {
  return (
    <motion.article
      className="video-card ne-card"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45 }}
      viewport={{ once: true }}
    >
      <div className="video-header card-header">
        <span className="section-kicker">Video</span>
        <h3>Featured Stories</h3>
      </div>

      {loading && <div className="video-wrapper ne-skeleton" />}

      {!loading && videos.length === 0 && (
        <div className="home-empty-state">Featured videos will appear here soon.</div>
      )}

      {!loading && videos.length > 0 && (
        <Carousel
          interval={5000}
          indicators={videos.length > 1}
          controls={videos.length > 1}
          prevIcon={
            <span className="video-arrow">
              <ChevronLeft />
            </span>
          }
          nextIcon={
            <span className="video-arrow">
              <ChevronRight />
            </span>
          }
        >
          {videos.map((v, i) => (
            <Carousel.Item key={v.id || v.url || i}>
              <div className="video-wrapper">
                <ReactPlayer url={v.url} width="100%" height="100%" controls />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </motion.article>
  );
};

export default VideoSection;
